module.exports = __webpack_public_path__ + "img/heading_no.d45e831f.svg";